/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./App.css";
import Router from "./router";
import Loader from "./components/Loader/Loader";
import { usePath } from "./context/PathContext";
import Header from "./components/layout/header/Header";
import Footer from "./components/layout/footer/Footer";
import ProfileFooter from "./components/layout/ProfileFooter/ProfileFooter";
import LayoutModal from "./components/modalLayout/LayoutModal";
import { useDashboardData } from "./Hooks/api/useDashboardData";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "./redux/slices/CartSlice";
import { useClearAllNfts } from "./Hooks/api/useClearAllNfts";
import { useGetCartNft } from "./Hooks/api/useGetCartList";

function App() {

  const dispatch =useDispatch()
  const { mutate } = useClearAllNfts(); 
  const { path } = usePath();
  const {data ,isLoading} = useDashboardData()
  const walletAddress = useSelector((state) => state.user.walletAddress);
  const { data: cartData } = useGetCartNft(walletAddress && walletAddress);

  const isEditProfilePage = path === "/edit-profile";
  const isProfilePage = path === "/profile";
  useEffect(() => {
    
   if(walletAddress && cartData?.length>0){
      const storedTime = localStorage.getItem("cartTimestamp");
      if (Date.now() > storedTime) {
        dispatch(clearCart());
        mutate({ wallet_address: walletAddress });
        localStorage.removeItem("cartTimestamp");
      }
    }
  }, [dispatch, walletAddress, mutate,cartData]);
  
  
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="max-w-[1920px] mx-auto bg-[--black]">
          <Header />
          <Router data={data}/>
          {(isEditProfilePage || isProfilePage) && <ProfileFooter />}
          {!isEditProfilePage && !isProfilePage && <Footer />}

          <LayoutModal />
        </div>
       )} 
    </>
  );
}

export default App;
